module.exports = __webpack_public_path__ + "img/transfer.a39a31ee.svg";